import { mapState } from 'vuex';
import { get, range } from 'lodash';
import formCheckbox from '@/components/market/market-detail-charts/checkbox/checkbox.vue';
import { INITIAL_MAX_CONTRACTS } from '@/components/market/market-detail-charts/market-detail-charts';

export default {
  components: {
    formCheckbox,
  },
  props: {
    contracts: {
      type: Array,
      required: true,
    },
    fillWithBlankColumns: { // so it's always fixed height
      type: Boolean,
      default: false,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState('market', ['chartType']),
    showImage() {
      return get(this.chartOptions, 'showContractImagesOnLegend', false);
    },
    blankColumns() {
      return (this.contracts.length < INITIAL_MAX_CONTRACTS) ?
        range(0, INITIAL_MAX_CONTRACTS - this.contracts.length) :
        [];
    },
  },
  methods: {
    contractName(item) {
      const chartIndex = get(this.chartOptions, 'chartIndex', null);
      if (chartIndex !== null) {
        return `checkbox-${chartIndex}-${item.contractName}-${item.marketId}`;
      }
      return `checkbox-${item.contractName}-${item.marketId}`;
    },
    imageStyleModifiers(item) {
      return {
        'border-color': item.lineColor,
        'background-image': `url(${item.contractImageSmallUrl})`,
      };
    },
    onChange(item, checked) {
      this.$emit('toggleItem', item, checked);
    },
    checkboxColor(item) {
      if (this.chartType === 'candle') return '#204b52';
      return item.additional ? item.additionalLineColor : item.lineColor;
    },
    tradeVolumeDisplay(item) {
      if (item.tradeVolume !== null) {
        return `${item.tradeVolume}`;
      }
      return '-';
    },
    chartPriceDisplay(item) {
      if (item.chartPrice !== null) {
        return `${item.chartPrice}¢`;
      }
      return '-';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-detail-charts/table/table.js